<template>
  <div
    class="
      tw-size-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-4
    "
    data-testid="checks-empty-panel"
  >
    <div
      class="
        tw-rounded-lg
        tw-bg-sf-snow-lighter
        tw-w-[900px]
        tw-px-4
        tw-flex
        tw-flex-col
        tw-gap-4
        tw-justify-center
        tw-items-center
      "
      :class="
        dataStatus === ChecksCalculationStatus.Calculating
          ? 'tw-pt-4 tw-pb-10'
          : 'tw-h-[400px]'
      "
    >
      <SfBannerInline
        v-if="dataStatus === ChecksCalculationStatus.Calculating"
        :title="I18n.t('assistant_check.page.stale_data_banner.title')"
        variant="info"
        :is-full-width="true"
        class="tw-mb-6 tw-size-full tw-block"
      />
      <img
        class="tw-max-w-[300px]"
        :src="$imagesRequire('empty_states/communication.svg')"
      />
      <div class="tw-font-medium tw-text-lg tw-text-sf-gray">
        {{ I18n.t('assistant_check.page.checks_container.empty.title') }}
      </div>
      <div class="tw-font-normal tw-text-sm tw-text-sf-gray">
        {{ I18n.t('assistant_check.page.checks_container.empty.text') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { ChecksCalculationStatus } from '../types'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'

import { useSfAssistantChecksPage } from '../stores/page'

const I18n = useI18n()

const pageStore = useSfAssistantChecksPage()
const { dataStatus } = storeToRefs(pageStore)
</script>
